export enum Cy_Reklamace {
  specifikaceTab = 'reklamace-specifikace-tab',

  kodReklamace = 'reklamace-kod-reklamace',
  kodOpravneni = 'reklamace-kod-opravneni',
  datumVytvoreni = 'reklamace-datum-vytvoreni',
  typ = 'reklamace-typ',
  datumZmeny = 'reklamace-datum-zmeny',
  status = 'reklamace-status',
  datumUkonceni = 'reklamace-datum-ukonceni',
  reklamujiciOsoba = 'reklamace-reklamujici-osoba',
  resitelReklamace = 'reklamace-resitel-reklamace',
  zapisujiciAis = 'reklamace-zapisujici-ais',
  zapisujiciOvm = 'reklamace-zapisujici-ovm',

  // Tlačítka
  search = 'reklamace-search-button',
  clear = 'reklamace-clear-filter-button',

  // Ostatní
  title = 'reklamace-title',
  table = 'reklamace-table',
  form = 'reklamace-form',
  actionButton = 'reklamace-action-button',

  /**
   * Detail
   */
}
